<template>
  <div class="base-card-info">
    <div class="info-card-title">
      代理商信息
    </div>
    <div class="base-info-list">
      <el-form
        ref="formRef"
        class="flex"
        require-asterisk-position="right"
        label-position="top"
        :model="info"
      >
        <div class="w-[432px] mr-[114px]">
          <el-form-item label="所属代理商">
            <el-select v-model="info.agentId" disabled>
              <el-option
                v-for="item in optionsAgent"
                :key="item.id"
                :label="item.agentName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="企业类型">
            <el-select v-model="info.companyType" disabled>
              <el-option :label="companyTypeLabel[ECompanyType.Personal]" :value="ECompanyType.Personal" />
              <el-option :label="companyTypeLabel[ECompanyType.Company]" :value="ECompanyType.Company" />
            </el-select>
          </el-form-item>
        </div>
        <div class="w-[432px]">
          <el-form-item label="销售">
            <el-select v-model="info.businessUserId" placeholder="--">
              <el-option
                v-for="item in optionsMange"
                :key="item.userId"
                :label="item.name"
                :value="item.userId"
              />
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { queryBusinessUserList, queryAgentList } from '@core/main';
import { IAgentOptionsItem, companyTypeLabel, ECompanyType, IAccCreateEnterprise, IManagePartyItem } from '@core/main/types';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import { useRoute } from 'vue-router';

defineOptions({ name: 'BaseInfoManage' }); // 账户中心 - 新增企业 - 设置代理商

const route = useRoute();

const optionsAgent = ref<IAgentOptionsItem[]>([]);
const optionsMange = ref<IManagePartyItem[]>([]);
const info = ref(JSON.parse(JSON.stringify(route.query)) as IAccCreateEnterprise);

async function getAgentList() {
  try {
    const { data } = await queryAgentList({}, true);

    optionsAgent.value = data;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function getManageList() {
  try {
    const { data } = await queryBusinessUserList(info.value.agentId);

    optionsMange.value = data;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

function init() {
  info.value.agentId = Number(info.value.agentId);
  info.value.businessUserId = Number(info.value.businessUserId);

  getManageList();
  getAgentList();

}

init();

defineExpose({
  /** 获取表单数据 */
  getValues: () => {
    const d = JSON.parse(JSON.stringify(info.value)) as IAccCreateEnterprise;

    d.type = d.companyType;
    delete d.companyType;

    return d;
  },
});
</script>

<style lang="scss" scoped>
:deep(.el-select__wrapper) {
  min-height: 40px;
}
</style>
